/** Add two valies that are possibly undefined */
export const safeAdd = (val0?: number, val1?: number): number | undefined => {
  if (!val0 && val1) {
    return val1;
  } 
  if (val0 && val1) {
    return val0 + val1;
  } 
  if (val0 && !val1) {
    return val0;
  }
  return undefined;
}

const OUNCES_TO_G_MULTIPLIER = 28.3495;
const POUNDS_TO_KG_MULTIPLIER = 0.453592;

export const convertOuncesToGrams = (oz: number): number => oz * OUNCES_TO_G_MULTIPLIER;

export const convertPoundsToKilograms = (lb: number): number => lb * POUNDS_TO_KG_MULTIPLIER;

